<script>
import 'vue-select/dist/vue-select.css'
import Multiselect from 'vue-multiselect'
//import { axiosGetPost } from '@router/axiosGetPost'

export default {
  name: 'DuplicateLog',
  props: {
    AdOptions: {
      type: [String, Number, Object],
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      dataCountries: [],
      dataHarbors: [],
      selectedCheckbox: [],
      addDataCountry: null,
      addCountries: [],
      showDelete: false,
      showModalWarning: false,
      showModalWarningEmpty: false,
      modalTitle: '',
      modalText: '',
      clearShow:true,
    }
  },
  created() {
    this.dataCountries = this.AdOptions.dataPlace
    this.addDataCountry = this.AdOptions.inputPlace

    /*if(this.addDataCountry[0].name == null ) {
      this.addDataCountry.splice(0, 1);
    }*/
    
  },
  watch: {
    selectedCheckbox(){
      if(this.selectedCheckbox.length > 0){
        this.showDelete = true;
      } else {
        this.showDelete = false;
      }
    }

  },
  methods: {
    allCountry(){
      this.showDelete = !this.showDelete;
      if(this.selectedCheckbox.length == this.addDataCountry.length) {
        return this.selectedCheckbox = [];
      }
      this.selectedCheckbox = [];
      let countCountries = this.addDataCountry.length;
      for (let step = 0; step < countCountries; step++) {
        this.selectedCheckbox.push(step);
      }
      return console.log(this.selectedCheckbox);
    },
    addCountry() {
      if(this.addCountries.length == 0) {
        this.showModalWarningEmpty = true;
      } else {
        this.addDataCountry.push(this.addCountries)
        this.addCountries = '';
      }
      if(this.addDataCountry[0].name == null ) {
        this.addDataCountry.splice(0, 1);
      }

      // return this.addDataCountry;
    },
    deleteCountry(index) {
      this.clearShow = false
      if(this.selectedCheckbox.length > 1) {
        this.selectedCheckbox.forEach(x => {
          if(this.addDataCountry.length == 1){
            console.log(x)
            //this.addDataCountry.indexOf(x) = [{ id: null, name: null }]
          } else {
            this.addDataCountry.splice(this.addDataCountry.indexOf(x),1)
          }
        });
        this.clearShow = true
        return this.selectedCheckbox = [];
      } else {
        if(this.addDataCountry.length == 1){
          this.addDataCountry[index] = { id: null, name: null }
        } else {
          this.addDataCountry.splice(index, 1);
        }
        this.clearShow = true
        return this.addDataCountry;
      }
    },
    savedata() {
      console.log(this.addDataCountry)
    },
  },
}
</script>

<template>
  <div class="table-responsive countries-modal">
    
    <table style="width: 100%">
      <thead>
        <th>
          <b-button v-if="showDelete" @click="deleteCountry" variant="outline-danger" size="sm"><i class="uil uil-trash"></i></b-button>
        </th>
        <th>
          <v-select
            v-model="addCountries"
            :options="dataCountries"
            label="name"
            class="bc-input bc-input-countries"
          >
            <template slot="no-options"> Type to search... </template>
          </v-select>
          <span v-if="showModalWarningEmpty">This field can't be empty.</span>
        </th>
        <th>
          
          <b-button variant="link" v-on:click="addCountry">Add</b-button>
          
        </th>
      </thead>
      <tbody v-if="clearShow">
        <tr
          v-for="(data, key) in addDataCountry"
          :key="key"
          :id="key"
          class="line-height-dataCountry"
        >
          <td>
            <b-form-checkbox
              :id="'country-'+key"
              v-model="selectedCheckbox"
              class="bc-checkbox-countries"
              :value="key"
            >
            </b-form-checkbox>
          </td>
          <td>{{ data.name }}</td>
          <td><b-button @click="deleteCountry(key)" class="btn-delete-country"><i class="uil uil-trash"></i></b-button></td>
        </tr>
        <!-- <b-button @click="savedata" class="btn-delete-country">Save</b-button> -->
      </tbody>
    </table>


    <!-- Modal Detele -->
    <b-modal
      id="modal-lg"
      v-model="showModalWarning"
      centered
      size="sm"
      title="Delete Countries"
      :hide-footer="true"
    >
      <p>You can't delete all countries. Please select again.</p>
    </b-modal>
  </div>
</template>

<style scoped>
.btn-delete-country {
  color: red;
  background: transparent;
  border: none;
}
.line-height-dataCountry {
  line-height: 3;
}
.countries-modal {
  height: 300px;
}

</style>